import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";


// Your web app's Firebase configuration from your Firebase project settings
const firebaseConfig = {
  apiKey: "AIzaSyDgGBNlcxRhlBmyeBOAgNafP9LZe3fI1OA",
  authDomain: "propertymanagement-2428f.firebaseapp.com",
  databaseURL: "https://propertymanagement-2428f-default-rtdb.firebaseio.com",
  projectId: "propertymanagement-2428f",
  storageBucket: "propertymanagement-2428f.firebasestorage.app",
  messagingSenderId: "301479455959",
  appId: "1:301479455959:web:e7039b0f4215b587f41492",
  measurementId: "G-MPBRYP9H92"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Auth instance
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// If you are using the Firebase Emulator, connect to it.
// The VITE_ or VUE_APP_ prefix is important for environment variables.
if (process.env.VUE_APP_USE_EMULATOR === 'true') {
  console.log('Connecting to Firebase Auth Emulator...');
  connectAuthEmulator(auth, "http://localhost:9099");
  // Point to the emulators running on your local machine
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export { auth ,db, functions };